import React from "react";
import { Button } from "@/components/ui/button";
import { SrIcon } from "@/components/ui/SrIcon";

interface BottomNavProps {
  step: number;
  totalSteps: number;
  onPrevious: () => void;
  onNext: () => void;
  onCreate: () => void;
  loading: boolean;
  aiLoading: boolean;
  /**
   * VIB-686: Ekstra disabled-flag for "Neste"-knappen som ikke handler om
   * AI-loading (f.eks. invoice_terms-sum != 100 %). Adskilt fra aiLoading
   * for å unngå at vi gjenbruker en uventet flag.
   */
  nextDisabled?: boolean;
  /** Tilsvarende for "Opprett prosjekt"-knappen. */
  createDisabled?: boolean;
}

export function BottomNav({
  step,
  totalSteps,
  onPrevious,
  onNext,
  onCreate,
  loading,
  aiLoading,
  nextDisabled = false,
  createDisabled = false,
}: BottomNavProps) {
  return (
    <div className="flex flex-col sm:flex-row gap-3 justify-between mt-8 pt-4 border-t">
      <Button
        variant="outline"
        onClick={onPrevious}
        disabled={step === 0}
        className="w-full sm:w-auto"
      >
        <SrIcon name="chevron-left" className="w-4 h-4 mr-1"  />
        Forrige
      </Button>
      {step < totalSteps - 1 ? (
        <Button
          onClick={onNext}
          disabled={aiLoading || nextDisabled}
          className="w-full sm:w-auto"
        >
          Neste
          <SrIcon name="chevron-right" className="w-4 h-4 ml-1"  />
        </Button>
      ) : (
        <Button
          onClick={onCreate}
          disabled={loading || createDisabled}
          className="w-full sm:w-auto"
        >
          {loading && <SrIcon name="loader2" className="w-4 h-4 mr-2 animate-spin"  />}
          Opprett prosjekt
        </Button>
      )}
    </div>
  );
}
